'use strict';
Ilduomo.
controller('operadoresInformacionController', function (
    $scope
    ,dataService) {
   dataService.getInformacionOperadores(function (response) {
       $scope.operadores = response.data;
   });
});